import { SegmentedControl } from '@cloudscape-design/components';
import { FC } from 'react';
import { useAuthContext } from '../contexts/AuthContext';
import { useModuleTranslation } from '../lang';
import { Lang } from '../lang/types';
import { Flag } from './Flag';

const LanguageSelector: FC = () => {
  const { language, setLanguage } = useAuthContext();
  const t = useModuleTranslation('LanguageSelector');

  return (
    <SegmentedControl
      selectedId={language}
      options={[
        { id: 'en', text: t.en, iconSvg: <Flag code="GB" />, iconAlt: t.en },
        { id: 'nl', text: t.nl, iconSvg: <Flag code="NL" />, iconAlt: t.nl },
        { id: 'no', text: t.no, iconSvg: <Flag code="NO" />, iconAlt: t.no },
      ]}
      onChange={({ detail }) => setLanguage(detail.selectedId as Lang)}
    />
  );
};

export default LanguageSelector;
